import { configureStore } from "@reduxjs/toolkit";
import toastReducer from './slice/toastSlice';
import surveyReducer from './slice/surveySlice';

export const store = configureStore({
  reducer: {
    toast: toastReducer,
    survey: surveyReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;